/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink', 'model/SWOTSessionParticipant', 'model/SWOTTopicReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'), require('./SWOTSessionParticipant'), require('./SWOTTopicReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SWOTSessionReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink, root.ForStractionServiceApi.SWOTSessionParticipant, root.ForStractionServiceApi.SWOTTopicReport);
  }
}(this, function(ApiClient, CorporateStructureLink, SWOTSessionParticipant, SWOTTopicReport) {
  'use strict';




  /**
   * The SWOTSessionReport model module.
   * @module model/SWOTSessionReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SWOTSessionReport</code>.
   * @alias module:model/SWOTSessionReport
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>SWOTSessionReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SWOTSessionReport} obj Optional instance to populate.
   * @return {module:model/SWOTSessionReport} The populated <code>SWOTSessionReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Participants')) {
        obj['Participants'] = ApiClient.convertToType(data['Participants'], [SWOTSessionParticipant]);
      }
      if (data.hasOwnProperty('Topics')) {
        obj['Topics'] = ApiClient.convertToType(data['Topics'], [SWOTTopicReport]);
      }
      if (data.hasOwnProperty('ModeratorID')) {
        obj['ModeratorID'] = ApiClient.convertToType(data['ModeratorID'], 'Integer');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('CreatedDate')) {
        obj['CreatedDate'] = ApiClient.convertToType(data['CreatedDate'], 'Date');
      }
      if (data.hasOwnProperty('LastCheckedDate')) {
        obj['LastCheckedDate'] = ApiClient.convertToType(data['LastCheckedDate'], 'Date');
      }
      if (data.hasOwnProperty('ActiveBatchDateStarted')) {
        obj['ActiveBatchDateStarted'] = ApiClient.convertToType(data['ActiveBatchDateStarted'], 'Date');
      }
      if (data.hasOwnProperty('ActiveBatchDateClosed')) {
        obj['ActiveBatchDateClosed'] = ApiClient.convertToType(data['ActiveBatchDateClosed'], 'Date');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/SWOTSessionParticipant>} Participants
   */
  exports.prototype['Participants'] = undefined;
  /**
   * @member {Array.<module:model/SWOTTopicReport>} Topics
   */
  exports.prototype['Topics'] = undefined;
  /**
   * @member {Integer} ModeratorID
   * @default 0
   */
  exports.prototype['ModeratorID'] = 0;
  /**
   * @member {Integer} StatusID
   * @default 0
   */
  exports.prototype['StatusID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Date} CreatedDate
   */
  exports.prototype['CreatedDate'] = undefined;
  /**
   * @member {Date} LastCheckedDate
   */
  exports.prototype['LastCheckedDate'] = undefined;
  /**
   * @member {Date} ActiveBatchDateStarted
   */
  exports.prototype['ActiveBatchDateStarted'] = undefined;
  /**
   * @member {Date} ActiveBatchDateClosed
   */
  exports.prototype['ActiveBatchDateClosed'] = undefined;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


